import { FilterField, FilterInputType } from 'layout/TableLayout/types.d';

const BUG_REPORT_LIST_FILTERS: FilterField[] = [
  {
    title: 'Дата создания с',
    type: FilterInputType.DATE,
    name: 'createdAtFrom',
  },
  {
    title: 'Дата создания по',
    type: FilterInputType.DATE,
    name: 'createdAtTo',
  },
  {
    title: 'Данные кандидата',
    type: FilterInputType.TEXT,
    name: 'candidate',
  },
  {
    title: 'Тема',
    type: FilterInputType.TEXT,
    name: 'topic',
  },
];

export default BUG_REPORT_LIST_FILTERS;
